export default {
  navigationBarTitleText: '搜索'
};
